import { useMutation, useQueryClient } from '@tanstack/react-query'
import RestDay from '../../model/RestDay'
import { dataSource } from '../../service/domain/_service.config'
import { useChallengeContext } from '../challenge/useChallengeContext'
import { useChallengeId } from '../challenge/useChallengeId'
import { useUser } from '../user/useUser'
import { REST_DAYS_QUERY_KEY } from './useRestDays'

export function useStartRestDay() {
  const queryClient = useQueryClient()
  const { data: user } = useUser()
  const challengeId = useChallengeId()
  const { data: challengeContext } = useChallengeContext()

  return useMutation({
    mutationFn: async () => {
      if (!user) throw new Error('User not found')
      if (!challengeId) throw new Error('No active challenge')
      if (!challengeContext || challengeContext.restDaysRequired <= 0) {
        throw new Error('This challenge has no rest days')
      }

      const duration = RestDay.getDurationMs()
      const restDay = RestDay.create(user.id, challengeId, duration)

      await dataSource.saveRestDay(restDay)

      queryClient.invalidateQueries({ queryKey: REST_DAYS_QUERY_KEY(user.id, challengeId) })

      return restDay
    },
  })
}
